// src/screens/Disputes/DisputeDecisionScreen.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../api';
import './DisputeDecisionScreen.css';
import backIcon from '../../assets/backspace-icon.png';

function DisputeDecisionScreen({ user }) {
  const { id } = useParams(); // this is orderId, not disputeId
  const navigate = useNavigate();

  const [dispute, setDispute] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDispute = async () => {
      try {
        console.log('🔍 Fetching dispute by order ID:', id);
        const res = await api.get(`/disputes/by-order/${id}`); // ✅ FIXED endpoint
        console.log('✅ Dispute data:', res.data);
        setDispute(res.data);
      } catch (err) {
        console.error('❌ Failed to load dispute:', err);
        setDispute(null);
      } finally {
        setLoading(false);
      }
    };

    fetchDispute();
  }, [id]);

  if (loading) {
    return <div className="dispute-decision-screen">Loading...</div>;
  }

  if (!dispute) {
    return (
      <div className="dispute-decision-screen">
        <div className="top-bar">
          <img
            src={backIcon}
            alt="Back"
            className="dispute-back-icon"
            onClick={() => navigate(-1)}
          />
          <h2>Dispute Decision</h2>
        </div>
        <div className="scroll-area">
          <p>❌ Dispute not found for this order.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dispute-decision-screen">
      <div className="top-bar">
        <img
          src={backIcon}
          alt="Back"
          className="dispute-back-icon"
          onClick={() => navigate(-1)}
        />
        <h2>Dispute Decision</h2>
      </div>

      <div className="scroll-area">
        <p><strong>Order ID:</strong> {dispute.orderId?._id?.slice(-6).toUpperCase()}</p>
        <p><strong>Buyer:</strong> {dispute.buyer}</p>
        <p><strong>Seller:</strong> {dispute.seller}</p>
        <p><strong>Reason:</strong> {dispute.reason}</p>
        <p><strong>Status:</strong> {dispute.status}</p>
        <p><strong>Submitted:</strong> {new Date(dispute.createdAt).toLocaleString()}</p>

        {dispute.finalDecision ? (
          <div className="decision-note">
            <strong>Admin Decision:</strong>
            <p><strong>Winner:</strong> {dispute.finalDecision.winner}</p>
            <p><strong>Reason:</strong> {dispute.finalDecision.reason}</p>
            <p><strong>Decided by:</strong> {dispute.finalDecision.decidedBy}</p>
            <p><strong>Decided at:</strong> {new Date(dispute.finalDecision.decidedAt).toLocaleString()}</p>
          </div>
        ) : (
          <div className="decision-note">
            <p>⚠️ No decision by Admins yet.</p>
          </div>
        )}

        <div className="media-section">
          <strong>Submitted Media:</strong>
          {dispute.mediaUrls?.length > 0 ? (
            <div className="media-grid">
              {dispute.mediaUrls.map((url, i) => (
                <img key={i} src={url} alt={`media-${i}`} className="media-thumb" />
              ))}
            </div>
          ) : (
            <p>No media submitted.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default DisputeDecisionScreen;
